// Edit benefit level
export const editBenefitLevel = {
	state: {
		isEditing: false,
		benefitLevel: {},
	},
	reducers: {
		toggleEditing(state, payload) {
			return {
				...state,
				isEditing: payload,
			};
		},
		setBenefitLevel(state, payload) {
			return {
				...state,
				benefitLevel: payload,
			};
		},
		resetState(state, payload) {
			return {
				isEditing: false,
				benefitLevel: {},
			};
		},
	},
	effects: (dispatch) => ({
		async setDataAsync(payload, rootState) {
			await new Promise((resolve) => resolve);
			dispatch.authData.toggleEditing(payload);
			dispatch.authData.setBenefitLevel(payload);
			dispatch.authData.resetState(payload);
		},
	}),
}
